/* RESPONSIBLE TEAM: team-automation-foundations */
import Controller from '@ember/controller';

export default class WorkflowsTroubleshootConversationsWithIdEventsEventController extends Controller {
  queryParams = ['eventTypes', 'status'];
}
